import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { FiMessageCircle } from 'react-icons/fi';
import './AeonasUnread.css';
import { useAuth } from '../auth/AuthContext';
import { configureSoundAccount, observeIncoming } from './chatSound';
import { beginBadgeRequest, syncAppIconBadge } from './appIconBadge';

export function useAeonasUnread() {
  const { user } = useAuth();
  const [unread, setUnread] = useState({ total: 0, counts: {}, dmLocations: {}, activity: {}, incoming: {}, deleted: {}, loaded: false });
  useEffect(() => {
    let alive = true;
    configureSoundAccount(user?.id);
    const refresh = () => {
      if (!user?.id) return;
      const badgeRequest = beginBadgeRequest();
      return axios.get('/api/chat/unread')
      .then(r => { if (alive) { syncAppIconBadge(r.data?.total, user.id, badgeRequest); observeIncoming(user.id,r.data?.incoming); setUnread({ total: Number(r.data?.total) || 0, counts: r.data?.counts || {}, dmLocations: r.data?.dmLocations || {}, activity: r.data?.activity || {}, incoming: r.data?.incoming || {}, deleted: r.data?.deleted || {}, loaded:true }); } })
      .catch(e => { if (alive && [401,403].includes(e.response?.status)) syncAppIconBadge(0,user.id,badgeRequest); });
    };
    const visibleRefresh = () => { if(document.visibilityState==='visible')refresh(); };
    refresh();
    const timer = setInterval(refresh, 6000);
    window.addEventListener('aeonas-chat-read', refresh);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', visibleRefresh);
    const onPush = event => { if(event.data?.type==='aeonas-badge-sync')refresh(); };
    navigator.serviceWorker?.addEventListener('message', onPush);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener('aeonas-chat-read', refresh);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', visibleRefresh);
      navigator.serviceWorker?.removeEventListener('message', onPush);
    };
  }, [user?.id]);
  return unread;
}

export function ChatBadge({ count }) {
  return count > 0 ? <span className="ae-unread-count">{count > 99 ? '99+' : count}</span> : null;
}

export function unreadDestination(counts = {}, dmLocations = {}) {
  const entries = Object.entries(counts).filter(([, n]) => Number(n) > 0)
    .sort((a, b) => Number(b[1]) - Number(a[1]));
  if (!entries.length) return '/chat';
  const [key] = entries[0];
  if (key.startsWith('studio:')) return '/chat?channel=studio&locationId=' + encodeURIComponent(key.slice(7));
  if (key.startsWith('dm:')) {
    const studio=Number(dmLocations[key]);
    return '/chat?channel=dm&peer=' + encodeURIComponent(key.slice(3)) + ([1,2,3].includes(studio) ? '&locationId=' + studio : '');
  }
  if (['announcements', 'artist', 'guestspots'].includes(key)) return '/chat?channel=' + key;
  return '/chat';
}

export function FloatingChat({ count, counts, dmLocations }) {
  const location = useLocation();
  if (location.pathname === '/chat') return null;
  return <Link className="ae-floating-chat" to={unreadDestination(counts, dmLocations)} aria-label={'Open chat' + (count ? ', ' + count + ' unread messages' : '')}>
    <FiMessageCircle size={23}/>
    <ChatBadge count={count}/>
  </Link>;
}
